import { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from 'react-router-dom';

import { Paginator, SearchAndFilterToolbar, StatusBar } from "../../components/common";


import PageBodyWrapper from "../../components/PageBodyWrapper";
import useApi from "../../api";
import ProductFilter from "../products/productFilter";
import InventoryTable from "./inventoryTable";

import enumChoice from "../../enum";

import { parseSearchParams } from "../common/filterableForm";
import { toast } from "react-toastify";
import { handleRetriveError } from "../../utils";


function InventoryMain() {

    const [products, setProducts] = useState<any>({});
    const [searchParams, setSearchParams] = useSearchParams()
    const [openFilterModal, setOpenFilterModal] = useState(false);
    const [filterData, setFilterData] =  useState<any>({});

    const api = useApi();
    const navigate = useNavigate();

    const fetchInventory = () => {
        const queryObject = parseSearchParams(searchParams);
        api.getInventories(queryObject).then((response: any) => {
            setProducts(response);
        }, handleRetriveError);
    };

    useEffect(() => {
        fetchInventory();
    }, [searchParams]);

    useEffect(() => {
        fetchInventory();
    }, []);


    return (
        <>  
            <PageBodyWrapper>
            <StatusBar 
                statusList={enumChoice.publishableStatus} 
            />

                <SearchAndFilterToolbar
                    onClearFilters={() => setFilterData({})}
                    onFilterOpen={() => setOpenFilterModal(!openFilterModal)}
                    onRefresh={fetchInventory}
                    startDateKey={"created_at_after"}
                    endDateKey={"created_at_before"}
                />
                {openFilterModal && <ProductFilter onClose={() => setOpenFilterModal(false)} />}
                <div className="relative overflow-x-auto">
                    <InventoryTable products={products} fetchInventory={fetchInventory} />
                    <Paginator data={products}/>
                </div>
            </PageBodyWrapper>
        </>
    );
}

export default InventoryMain;
